module.exports = __webpack_public_path__ + "img/bg-cara.d99e4623.svg";